module.exports = __webpack_public_path__ + "img/event-bg.5e5d4512.png";